<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf" :bordered='false'>
      <a-table v-if='deliverData.detail||deliverData.order_goods' :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='deliverData.detail|| deliverData.order_goods'>
        <template v-slot:good="{ record }">
          <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image || record.goods_image)" alt="" style="width:50px">
            </template>
            <template #description>
              <p class="s_omit">{{record.product_name || record.goods_name}}</p>
            </template>
          </a-card-meta>
        </template>
      </a-table>
      <a-form class="m-t-30" ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="" label="收货地址" name="" v-if='deliverData.extract'>
          <p><span class="m-r-15">{{deliverData.extract.extract_name}} {{deliverData.extract.extract_phone}}</span> {{deliverData.extract.detail}}</p>
        </a-form-item>
          <a-form-item ref="" label="收货地址" name="" v-if='!deliverData.extract'>
          <p>{{deliverData.name}}，{{deliverData.mobile}}，{{deliverData.address}}</p>
        </a-form-item>
        <a-form-item ref="delivery_type" label="发货方式" name="delivery_type">
          <a-radio-group v-model:value="form.delivery_type">
            <a-radio :value="1">
              快递配送
            </a-radio>
            <a-radio :value="2" v-if='!isInsteadShip'>
              当面交易，无需物流
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item ref="express_id" label="物流公司" name="express_id" v-if='form.delivery_type == 1'>
          <a-select v-model:value="form.express_id" :style="{width:'200px'}" placeholder="请选择物流公式" @change="changeExpress">
            <a-select-option v-for='item in list' :key='item.id' :value="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item ref="express_no" label="运单号" name="express_no" v-if='form.delivery_type == 1'>
          <a-input v-model:value="form.express_no" placeholder='请输入运单号' />
        </a-form-item>
        <a-form-item ref="store_remark" label="备注" name="store_remark">
          <a-textarea v-model:value="form.store_remark" showCount :maxlength="200" placeholder="请输入备注" :rows="4" />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit" :loading='loading'>确定</a-button>
        </a-form-item>
      </a-form>
    </div>
  </a-layout>
</template>
<script>
import { ref, watchEffect, reactive, toRefs, inject, onMounted } from "vue";
import {
  getExpressList,
  orderDelivery,
  getorderDeliveryEdit,
  orderDeliveryEdit,
} from "@/api/order";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import store from "@/store";
import { forEach } from 'lodash';

// 初始化默认筛选项数值
let defForm = {
  delivery_type: 1,
  express_no: "",
  express_id: undefined,
  store_remark: "",
};
export default {
  name: "deliverForem",
  components: {},
  props: {
    deliverData: {
      type: Object,
    },
    type: {
      type: Number,
    },
    isInsteadShip: { // 是否只是快递发货
      type: Number,
    },
  },
  setup(props, { emit }) {
    let columns = [
      {
        title: "商品",
        key: "good",
        slots: { customRender: "good" },
      },
      {
        title: "数量",
        dataIndex: "buy_num",
        key: "buy_num",
        customRender: ({ record }) => {
          return record.buy_num || record.goods_num;
        },
      },
    ];
    const form = ref({ ...defForm });
    const state = reactive({
      info: store.state.user.info,
      list: [],
      deliverData: {},
      loading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      rules: {
        resource: [{ required: true, message: "请选择发货方式" }],
        express_id:[{ required: true, message: "请选择物流公司" }],
        express_no:[{ required: true, message: "请输入订单号" }]
      },
    });
    const ruleForm = ref();
    const _lodash = inject("_lodash");
    const initData = async () => {
      let res = await getExpressList({ keyword: "", limit: 100, page: 1 }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.list = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    const getMore = async () => {
      let res = await getorderDeliveryEdit({
        order_no: state.deliverData.order_no,
      }).then((res) => res.data);
      if (iscode(res)) {
        form.value = res.data;
      } else {
        message.error(res.msg);
      }
    };
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async () => {
          if (props.type == 3) {
            // type 为3时传递参数出去 不请求
            emit("submitdeliver", {
              ...form.value,
              order_sn: state.deliverData.order_sn,
            });
            return;
          }
          state.loading = true;
          let res = await orderDelivery({
            ...form.value,
            order_no: state.deliverData.order_no,
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res)) {
            emit("submitdeliver", form.value);
            message.success(res.msg);
          } else {
            message.error(res.msg);
          }
          state.loading = false;
        })
        .catch((error) => {
          message.error("请完善表单！");
        });
    };
    const changeExpress=(e)=>{
      console.log(e)
      state.list.forEach(v=>{
        if(v.id==e){
          form.value.express_name=v.name
        }
      })
    }
    onMounted(() => {
      initData();
      var deliverData = props.deliverData || {};
      if (!_lodash.isEmpty(deliverData)) {
        state.deliverData = deliverData;
      }
      if (props.type == 2) {
        getMore();
      }
    });
    return {
      form,
      columns,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      changeExpress
    };
  },
};
</script>